import {routes as effContractRoutes} from  './eff_contract'
import {routes as stmHostelRoutes} from './stm_hostel'

export const routes = [
  ...effContractRoutes,
  ...stmHostelRoutes
]